<div class="layout-wrapper" [ngClass]="containerClass()">
    <div app-sidebar></div>
    <div class="layout-content-wrapper">
        <div class="layout-content-wrapper-inside">
            <div app-topbar></div>
            <div class="layout-content">
                <div app-breadcrumb></div>
                <router-outlet></router-outlet>
            </div>
            <div app-footer></div>
        </div>
    </div>
    <div class="layout-mask"></div>
</div>
